export default "__VITE_ASSET__a85610d5__"